const styles = {
  container: {
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  checkboxCell: {
    flexBasis: '10%',
  },
  descriptionCell: batchEdit => ({
    flexBasis: batchEdit ? '40%' : '50%',
  }),
  dateCell: {
    flexBasis: '20%',
  },
  spinnerContainer: {
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectList.styles.js